'use client';

import { useContext } from 'react';
import { CookieConsentContext } from './cookie-consent-context';


export function useCookieConsent () {
    const context = useContext(CookieConsentContext);

    if (!context) {
        throw new Error('CookieConsentProvider is missing');
    }

    return context;
}
